{
    "api_request_count": {
        "behavior": "sum",
        "description": "The number of API requests made to your newsletter.",
        "mode": "chart",
        "name": "API request count",
        "route": "/requests",
        "value": "count",
        "variant": "timeseries"
    },
    "automation_click_rate": {
        "behavior": "average",
        "description": "The rate at which links in your automated emails have been clicked.",
        "mode": "chart",
        "name": "Automation click rate",
        "route": "/automations",
        "value": "percentage",
        "variant": "qualitative"
    },
    "automation_clicks": {
        "behavior": "sum",
        "description": "The number of times links in your automated emails have been clicked.",
        "mode": "chart",
        "name": "Automation clicks",
        "route": "/automations",
        "value": "count",
        "variant": "qualitative"
    },
    "automation_deliveries": {
        "behavior": "sum",
        "description": "The number of times your automated emails have been delivered.",
        "mode": "chart",
        "name": "Automation deliveries",
        "route": "/automations",
        "value": "count",
        "variant": "qualitative"
    },
    "automation_open_rate": {
        "behavior": "average",
        "description": "The rate at which your automated emails have been opened.",
        "mode": "chart",
        "name": "Automation open rate",
        "route": "/automations",
        "value": "percentage",
        "variant": "qualitative"
    },
    "automation_opens": {
        "behavior": "sum",
        "description": "The number of times your automated emails have been opened.",
        "mode": "chart",
        "name": "Automation opens",
        "route": "/automations",
        "value": "count",
        "variant": "qualitative"
    },
    "blocked_subscribers": {
        "behavior": "sum",
        "dateParameter": "date",
        "description": "The number of subscribers blocked by the firewall.",
        "mode": "chart",
        "name": "Blocked subscribers",
        "polarity": "negative",
        "route": "/subscribers",
        "value": "count",
        "variant": "timeseries"
    },
    "bluesky_followers": {
        "behavior": "latest",
        "dateParameter": "date",
        "description": "The number of followers on your Bluesky account.",
        "mode": "chart",
        "name": "Bluesky followers",
        "route": "/inbox",
        "value": "count",
        "variant": "timeseries"
    },
    "browsers": {
        "behavior": "sum",
        "description": "The browsers used by your subscribers.",
        "mode": "chart",
        "name": "Browsers",
        "route": "/subscribers",
        "value": "percentage",
        "variant": "proportion"
    },
    "click_rate": {
        "behavior": "average",
        "description": "The percentage of subscribers that have clicked a link your emails.",
        "mode": "chart",
        "name": "Click rate",
        "route": "/emails",
        "value": "percentage",
        "variant": "qualitative"
    },
    "clicks": {
        "behavior": "sum",
        "description": "The number of times links in your emails have been clicked.",
        "mode": "chart",
        "name": "Clicks",
        "route": "/emails",
        "value": "count",
        "variant": "qualitative"
    },
    "comments": {
        "behavior": "sum",
        "description": "The number of comments on your newsletter's archives.",
        "mode": "chart",
        "name": "Comments",
        "route": "/comments",
        "value": "count",
        "variant": "timeseries"
    },
    "comments_by_email": {
        "behavior": "sum",
        "description": "The number of comments on your newsletter's archives, broken down by email.",
        "mode": "chart",
        "name": "Comments by email",
        "route": "/comments",
        "value": "count",
        "variant": "qualitative"
    },
    "complaint_rate": {
        "behavior": "average",
        "description": "The percentage of subscribers that have complained about your emails.",
        "mode": "chart",
        "name": "Complaint rate",
        "polarity": "negative",
        "route": "/emails",
        "value": "percentage",
        "variant": "qualitative"
    },
    "confirmation_rate": {
        "behavior": "average",
        "description": "The percentage of subscribers that have confirmed their subscription.",
        "mode": "chart",
        "name": "Confirmation rate",
        "route": "/subscribers",
        "value": "percentage",
        "variant": "timeseries"
    },
    "confirmed_subscribers": {
        "behavior": "sum",
        "dateParameter": "date",
        "description": "The number of subscribers who have confirmed their subscription.",
        "mode": "chart",
        "name": "Confirmed subscribers",
        "route": "/subscribers",
        "value": "count",
        "variant": "timeseries"
    },
    "active_subscribers": {
        "behavior": "latest",
        "dateParameter": "date",
        "description": "The number of active subscribers (confirmed minus deleted or unsubscribed).",
        "mode": "chart",
        "name": "Active subscribers",
        "route": "/subscribers",
        "value": "count",
        "variant": "timeseries"
    },
    "countries": {
        "behavior": "sum",
        "description": "The countries your subscribers are from.",
        "mode": "chart",
        "name": "Countries",
        "route": "/subscribers",
        "value": "percentage",
        "variant": "proportion"
    },
    "created_subscribers": {
        "behavior": "sum",
        "dateParameter": "date",
        "description": "The number of new subscribers.",
        "mode": "chart",
        "name": "New subscribers",
        "route": "/subscribers",
        "value": "count",
        "variant": "timeseries"
    },
    "devices": {
        "behavior": "sum",
        "description": "The devices used by your subscribers.",
        "mode": "chart",
        "name": "Devices",
        "route": "/subscribers",
        "value": "percentage",
        "variant": "proportion"
    },
    "gross_volume": {
        "behavior": "sum",
        "description": "The raw payment volume accumulated.",
        "mode": "chart",
        "name": "Gross volume",
        "route": "/settings/paid-subscriptions",
        "value": "monetary",
        "variant": "timeseries"
    },
    "mentions": {
        "behavior": "sum",
        "description": "The number of times your newsletter's archives have been mentioned on other websites.",
        "mode": "chart",
        "name": "Mentions",
        "route": "/emails",
        "value": "count",
        "variant": "timeseries"
    },
    "mentions_by_email": {
        "behavior": "sum",
        "description": "The number of times your newsletter's archives have been mentioned on other websites, broken down by email.",
        "mode": "chart",
        "name": "Mentions by email",
        "route": "/emails",
        "value": "count",
        "variant": "qualitative"
    },
    "mastodon_followers": {
        "behavior": "latest",
        "dateParameter": "date",
        "description": "The number of followers on your Mastodon account.",
        "mode": "chart",
        "name": "Mastodon followers",
        "route": "/inbox",
        "value": "count",
        "variant": "timeseries"
    },
    "monthly_recurring_revenue": {
        "behavior": "latest",
        "description": "The monthly recurring revenue of your newsletter.",
        "mode": "chart",
        "name": "Monthly recurring revenue",
        "route": "/settings/paid-subscriptions",
        "value": "monetary",
        "variant": "timeseries"
    },
    "open_rate": {
        "behavior": "average",
        "description": "The percentage of subscribers that have opened your emails.",
        "mode": "chart",
        "name": "Open rate",
        "route": "/emails",
        "value": "percentage",
        "variant": "qualitative"
    },
    "opens": {
        "behavior": "sum",
        "description": "The number of times your emails have been opened.",
        "mode": "chart",
        "name": "Opens",
        "route": "/emails",
        "value": "count",
        "variant": "qualitative"
    },
    "page_views": {
        "behavior": "sum",
        "description": "The number of times your newsletter's archives have been viewed.",
        "mode": "chart",
        "name": "Page views",
        "route": "/emails",
        "value": "count",
        "variant": "timeseries"
    },
    "page_views_by_country": {
        "behavior": "sum",
        "description": "The number of times your newsletter's archives have been viewed, broken down by country.",
        "mode": "chart",
        "name": "Page views by country",
        "route": "/emails",
        "value": "count",
        "variant": "qualitative"
    },
    "page_views_by_device": {
        "behavior": "sum",
        "description": "The number of times your newsletter's archives have been viewed, broken down by device.",
        "mode": "chart",
        "name": "Page views by device",
        "route": "/emails",
        "value": "count",
        "variant": "qualitative"
    },
    "page_views_by_email": {
        "behavior": "sum",
        "description": "The number of times your newsletter's archives have been viewed, broken down by email.",
        "mode": "chart",
        "name": "Page views by email",
        "route": "/emails",
        "value": "count",
        "variant": "qualitative"
    },
    "page_views_by_os": {
        "behavior": "sum",
        "description": "The number of times your newsletter's archives have been viewed, broken down by operating system.",
        "mode": "chart",
        "name": "Page views by OS",
        "route": "/emails",
        "value": "count",
        "variant": "qualitative"
    },
    "page_views_by_referrer": {
        "behavior": "sum",
        "description": "The number of times your newsletter's archives have been viewed, broken down by referrer.",
        "mode": "chart",
        "name": "Page views by referrer",
        "route": "/emails",
        "value": "count",
        "variant": "proportion"
    },
    "paid_subscribers": {
        "behavior": "sum",
        "description": "The number of subscribers who have paid for a subscription.",
        "mode": "chart",
        "name": "Paid subscribers",
        "route": "/settings/paid-subscriptions",
        "value": "count",
        "variant": "timeseries"
    },
    "paid_subscribers_by_price": {
        "behavior": "sum",
        "description": "The number of paid subscribers broken down by subscription price.",
        "mode": "chart",
        "name": "Paid subscribers by price",
        "route": "/settings/paid-subscriptions",
        "value": "count",
        "variant": "qualitative"
    },
    "permanent_failure_rate": {
        "behavior": "average",
        "description": "The percentage of emails that have failed to be delivered.",
        "mode": "chart",
        "name": "Permanent failure rate",
        "polarity": "negative",
        "route": "/emails",
        "value": "percentage",
        "variant": "qualitative"
    },
    "popular_urls": {
        "behavior": "sum",
        "description": "The most popular URLs in your emails.",
        "mode": "chart",
        "name": "Popular URLs",
        "route": "/emails",
        "value": "count",
        "variant": "qualitative"
    },
    "referrals": {
        "behavior": "sum",
        "description": "The number of subscribers referred by other subscribers.",
        "mode": "chart",
        "name": "Referrals",
        "route": "/subscribers",
        "value": "count",
        "variant": "timeseries"
    },
    "retention": {
        "behavior": "average",
        "description": "The percentage of subscribers that have remained subscribed over the timespan.",
        "mode": "number",
        "name": "Retention",
        "route": "/subscribers",
        "value": "percentage",
        "variant": "qualitative"
    },
    "rss_subscribers": {
        "behavior": "sum",
        "description": "The number of subscribers to your RSS feed.",
        "mode": "chart",
        "name": "RSS subscribers",
        "route": "/subscribers",
        "value": "count",
        "variant": "qualitative"
    },
    "undeliverable_subscribers": {
        "behavior": "sum",
        "dateParameter": "undeliverability_date",
        "description": "The number of subscribers marked as undeliverable.",
        "mode": "chart",
        "name": "Undeliverable subscribers",
        "polarity": "negative",
        "route": "/subscribers",
        "value": "count",
        "variant": "timeseries"
    },
    "unsubscribe_rate": {
        "behavior": "average",
        "description": "The percentage of subscribers that have unsubscribed.",
        "mode": "chart",
        "name": "Unsubscribe rate",
        "polarity": "negative",
        "route": "/subscribers",
        "value": "percentage",
        "variant": "qualitative"
    },
    "unsubscribes": {
        "behavior": "sum",
        "dateParameter": "unsubscription_date",
        "description": "The number of subscribers who unsubscribed from your emails.",
        "mode": "chart",
        "name": "Unsubscribes",
        "polarity": "negative",
        "route": "/subscribers",
        "value": "count",
        "variant": "qualitative"
    },
    "unsubscription_reasons": {
        "behavior": "sum",
        "description": "The reasons given by subscribers for unsubscribing.",
        "mode": "chart",
        "name": "Unsubscription reasons",
        "route": "/subscribers",
        "value": "percentage",
        "variant": "proportion"
    }
}
